import { render, staticRenderFns } from "./ShopArticleEditComponent.vue?vue&type=template&id=44e34005&scoped=true"
import script from "./ShopArticleEditComponent.vue?vue&type=script&lang=js"
export * from "./ShopArticleEditComponent.vue?vue&type=script&lang=js"
import style0 from "./ShopArticleEditComponent.vue?vue&type=style&index=0&id=44e34005&prod&lang=less&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "44e34005",
  null
  
)

export default component.exports